import { render, staticRenderFns } from "./TrainingRegistration_1.vue?vue&type=template&id=f5c2e960&"
import script from "./TrainingRegistration_1.vue?vue&type=script&lang=js&"
export * from "./TrainingRegistration_1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports